export default __webpack_public_path__ + "static/media/blogimage4.66cdf7f7.png";